import { useEffect, useRef, useState } from "react";
import {
  createLiveRecordingAnalyser,
  LIVE_WAVEFORM_BAR_COUNT,
  LIVE_WAVEFORM_UPDATE_INTERVAL_MS,
  recordingWaveformProgress,
  type LiveRecordingAnalyser,
} from "./live-recording-waveform.js";

export function useLiveRecordingWaveform(input: {
  stream: MediaStream | null;
  active: boolean;
  elapsedMs: number;
}): {
  barHeights: readonly number[] | null;
  progress: number;
} {
  const analyserRef = useRef<LiveRecordingAnalyser | null>(null);
  const [barHeights, setBarHeights] = useState<readonly number[] | null>(null);

  useEffect(() => {
    if (!input.active || input.stream == null) {
      analyserRef.current?.dispose();
      analyserRef.current = null;
      setBarHeights(null);
      return;
    }

    const analyser = createLiveRecordingAnalyser(input.stream, LIVE_WAVEFORM_BAR_COUNT);
    analyserRef.current = analyser;
    setBarHeights(analyser.sampleBarHeights());

    const intervalId = window.setInterval(() => {
      setBarHeights(analyser.sampleBarHeights());
    }, LIVE_WAVEFORM_UPDATE_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
      analyser.dispose();
      if (analyserRef.current === analyser) {
        analyserRef.current = null;
      }
    };
  }, [input.active, input.stream]);

  return {
    barHeights,
    progress: input.active ? recordingWaveformProgress(input.elapsedMs) : 0,
  };
}
